<ng-container *transloco="let t;">
  <div class="card-header pb-50">
    <div class="d-flex align-items-center">
      <h4 class="card-title font-medium-1">{{ t('Task and Reminders (Dashboard task and reminders widget title) - Task and reminders') }}</h4>
    </div>
  </div>
  <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="taskReminderWidgetScroll">
    <div class="card-body">
      <ul class="timeline">
        @for(reminderSetting of (_taskAndReminderSettings$ | async); track reminderSetting){
          <li class="timeline-item">
            <ng-container *ngIf="reminderSetting?.due_date">
             <span class="timeline-point timeline-point-indicator" [ngClass]="'timeline-point-' + (reminderSetting?.due_date | todoStatusBadge: 'class' | async)"></span>
             <div class="timeline-event">
               <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                 <h6 class="mb-0 activity-Links-h6"><a class="activity-Links cursor-pointer" [routerLink]="['/contract-control/view/', reminderSetting?.contract_control?.id]">{{ reminderSetting?.description }}</a></h6>
                 <div>
                   <span class="badge" [ngClass]="'badge-light-' + (reminderSetting?.due_date | todoStatusBadge: 'class' | async)">{{ reminderSetting?.due_date | todoStatusBadge: 'status' | async }}</span>
                 </div>
               </div>
               <div class="font-small-3 mb-50 reminderswidgetData">
                 <p class="me-25 font-small-3 d-inline">{{ t('Related to task and reminders widget text - (Dashboard section) - Related to') }}</p>
                 <h6 class="mb-0 d-inline font-small-3 activity-Links me-25">{{ reminderSetting?.contract_control?.contract_control_name }}</h6>
                 <p class="font-small-3 d-inline" *ngIf="reminderSetting?.todo_user?.length">{{ t('Assigned to task and reminders widget text - (Dashboard section) - Assigned to') }}</p>
                 <ng-container *ngFor="let todoUser of reminderSetting?.todo_user; let i = index">
                    <h6 class="mb-0 d-inline font-small-3 activity-Links">
                      {{i > 0 ? ', ' : ''}}{{(todoUser?.userable?.name).trim()}}
                    </h6>
                  </ng-container>                  
                </div>
             </div>
            </ng-container>
           </li>
        } @empty {
          <div class="mb-1 p-4 mt-1 text-center cc-no-recordsDiv">
            <p class="text-muted mb-0">{{ t('No records (general) - No records') }}</p>
          </div>
        }
      </ul>
    </div>
  </ng-scrollbar>
</ng-container>
